export const QuestionHeader = ({ label, description, required }) => {
  return (
    <div className="space-y-2 text-left flex-shrink-0">
      <label className="block text-xl md:text-2xl font-semibold text-text-primary">
        {label}
        {required && <span className="text-error ml-1">*</span>}
      </label>

      {description && <p className="text-error text-xs">{description}</p>}
    </div>
  );
};
